import styled from 'styled-components'

export const MainWrapper = styled.main`
	max-width: 1520px;
	background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
	border-radius: 15px;
	margin-top: 70px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.3);
`
export const Content = styled.div`
	padding: 50px 0;
`
export const Header = styled.h1`
	margin-left: 40px;
	color: #f3f4f6;
`
export const HeaderWrapper = styled.div`
	margin-bottom: 30px;
`
